import MainAsideLayout from '@/components/mainAsideLayout/MainAsideLayout';
import { RichText } from '@/components/richText/RichText';
import BaseDownloadCard from '@/storyblok/baseDownloadCard/BaseDownloadCard';
import type { ComponentDownloadsCardStoryblok } from '@/types/component-types-sb';
import { ColumnWidth, type ResponsiveLayout } from '@/types/layoutTypes';
import { storyblokEditable } from '@storyblok/react/rsc';

const ComponentDownloadsCard: React.FC<{ blok: ComponentDownloadsCardStoryblok }> = ({ blok }) => {
  let textWidth: ResponsiveLayout = { desktopUp: ColumnWidth.ONE_THIRD, desktopMaxUp: ColumnWidth.HALF };
  switch (blok.size) {
    case 'small':
      textWidth = { tabletUp: ColumnWidth.HALF, desktopUp: ColumnWidth.THREE_QUARTER };
      break;
    case 'medium':
      textWidth = { desktopUp: ColumnWidth.ONE_THIRD, desktopMaxUp: ColumnWidth.HALF };
      break;
    case 'large':
      textWidth = { desktopMaxUp: ColumnWidth.ONE_THIRD };
      break;
  }
  return (
    <MainAsideLayout
      main={<RichText text={blok.text} />}
      aside={
        <BaseDownloadCard
          title={blok.title}
          files={blok.files}
          size={blok.size || undefined}
          {...storyblokEditable(blok)}
        />
      }
      mainColumnWidth={textWidth}
      blok={blok}
      anchor={blok.anchor}
    />
  );
};

export default ComponentDownloadsCard;
